import styled from 'styled-components/macro';
import { Row, Col } from '@yme/atoms/grid';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE, MAX_DESKTOP } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { HeadingLevel1 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const HeroBannerStyled = styled.div `
  position: relative;
  min-height: 154px;
  display: flex;
  align-items: flex-end;
  box-sizing: border-box;
  padding: ${INDENT.xs} 0;

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  ${ADAPTIVE.minWidth.tablet} {
    padding-bottom: ${INDENT.sm};
    min-height: 330px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding-bottom: ${INDENT.xxxxl};
    min-height: 405px;
    max-width: ${MAX_DESKTOP};
    margin: 0 auto;
  }
`;
export const RowStyled = styled(Row) `
  ${ADAPTIVE.minWidth.desktop} {
    margin: 0;
  }
`;
export const ColStyled = styled(Col) `
  ${ADAPTIVE.minWidth.desktop} {
    flex-grow: 1;
    max-width: 100%;
    margin: 0;
  }
`;
export const TitleStyled = styled(HeadingLevel1) `
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;

  ${getTextStyles(null, null, 24, 28)}

  ${ADAPTIVE.minWidth.tablet} {
    -webkit-line-clamp: 1;

    ${getTextStyles(null, null, 32, 40)}
  }

  ${ADAPTIVE.minWidth.desktop} {
    ${getTextStyles(null, null, 48, 56)}
  }
`;
export const TitleWrapperStyled = styled(FlexWrapper) `
  gap: ${INDENT.xs};

  ${ADAPTIVE.minWidth.tablet} {
    gap: ${INDENT.sm};
  }
`;
